export default __webpack_public_path__ + "static/media/aqr-icon.11e34721.svg";